import React, { useState } from 'react';
import { ClubMember } from '@shared/integrations/taf-api/v1/models';
import { formatDate } from '@shared/utils/dateUtils';
import { EMPTY_VALUE } from '@shared/utils/misc';

interface MemberTableProps {
    members: ClubMember[];
}


const MemberTable: React.FC<MemberTableProps> = ({ members }) => {
    const [filter, setFilter] = useState<string>('');

    if (!members || members.length === 0) {
        return (
            <div className="alert alert-info">
                <p>Inga medlemmar att visa.</p>
            </div>
        );
    }

    // Filter members based on search input
    const filteredMembers = filter
        ? members.filter((member) => {
              const searchTerm = filter.toLowerCase();
              return (
                  member.fullName?.toLowerCase().includes(searchTerm) ||
                  member.email1?.toLowerCase().includes(searchTerm) ||
                  member.mobilePhone?.toLowerCase().includes(searchTerm) ||
                  member.workplace?.toLowerCase().includes(searchTerm)
              );
          })
        : members;

    return (
        <>
            <div className='search-box mb-4'>
                <svg
                    className='search-box-icon'
                    width='20'
                    height='20'
                    viewBox='0 0 40 40'
                    xmlns='http://www.w3.org/2000/svg'
                >
                    <path
                        d='M24.828 31.657a16.76 16.76 0 0 1-7.992 2.015C7.538 33.672 0 26.134 0 16.836 0 7.538 7.538 0 16.836 0c9.298 0 16.836 7.538 16.836 16.836 0 3.22-.905 6.23-2.475 8.79.288.18.56.395.81.645l5.985 5.986A4.54 4.54 0 0 1 38 38.673a4.535 4.535 0 0 1-6.417-.007l-5.986-5.986a4.545 4.545 0 0 1-.77-1.023zm-7.992-4.046c5.95 0 10.775-4.823 10.775-10.774 0-5.95-4.823-10.775-10.774-10.775-5.95 0-10.775 4.825-10.775 10.776 0 5.95 4.825 10.775 10.776 10.775z'
                        fillRule='evenodd'
                    ></path>
                </svg>
                <input
                    id='memberFilter'
                    className='search-box-input'
                    name='memberFilter'
                    type='text'
                    placeholder='Sök efter medlem...'
                    value={filter}
                    onChange={(event) => setFilter(event.target.value)}
                />
            </div>

            {filteredMembers.length === 0 ? (
                <div className='alert alert-info'>
                    <p>Inga medlemmar hittades för sökningen "{filter}".</p>
                </div>
            ) : (
                <div className='ft-table ft-responsive-sm table-mark-empty font-size-sm'>
                    <div className='ft-thead'>
                        <div className='ft-tr'>
                            <div className='ft-th'>#</div>
                            <div className='ft-th'>Namn</div>
                            <div className='ft-th'>E-post</div>
                            <div className='ft-th'>Mobiltelefon</div>
                            <div className='ft-th'>Medlem sedan</div>
                            <div className='ft-th'>Arbetsplats</div>
                        </div>
                    </div>
                    <div className='ft-tbody'>
                        {filteredMembers.map((member, index) => (
                            <div key={index} className='ft-tr'>
                                <div className='ft-td'>{index + 1}</div>
                                <div className='ft-td'>{member.fullName || EMPTY_VALUE}</div>
                                <div className='ft-td'>
                                    {member.email1 ? (
                                        <a href={`mailto:${member.email1}`}>{member.email1}</a>
                                    ) : (
                                        EMPTY_VALUE
                                    )}
                                </div>
                                <div className='ft-td'>{member.mobilePhone || EMPTY_VALUE}</div>
                                <div className='ft-td'>{member.memberFrom ? formatDate(member.memberFrom) : EMPTY_VALUE}</div>
                                <div className='ft-td'>{member.workplace || EMPTY_VALUE}</div>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </>
    );
};

export default MemberTable;
